var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.printMode
        ? [
            _c(
              "a-row",
              { attrs: { gutter: 24 } },
              [
                _c(
                  "a-col",
                  { attrs: { md: 24 } },
                  [
                    _c(
                      "a-card",
                      { style: _vm.cardStyle, attrs: { bordered: false } },
                      [
                        _c(
                          "div",
                          { staticClass: "table-page-search-wrapper" },
                          [
                            _c(
                              "a-form",
                              {
                                attrs: { layout: "inline" },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.searchQuery.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "a-row",
                                  { attrs: { gutter: 24 } },
                                  [
                                    _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "门店",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("store-tenant-select", {
                                              attrs: { domain: "sale" },
                                              on: {
                                                change:
                                                  _vm.handleStoreTenantChange,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "单据日期",
                                              labelCol: _vm.labelCol,
                                              wrapperCol: _vm.wrapperCol,
                                            },
                                          },
                                          [
                                            _c("a-range-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                format: "YYYY-MM-DD",
                                                placeholder: [
                                                  "开始日期",
                                                  "结束日期",
                                                ],
                                              },
                                              on: { change: _vm.onDateChange },
                                              model: {
                                                value: _vm.queryParam.dateRange,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryParam,
                                                    "dateRange",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryParam.dateRange",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "table-page-search-submitButtons",
                                        },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: { type: "primary" },
                                              on: { click: _vm.searchQuery },
                                            },
                                            [_vm._v("查询")]
                                          ),
                                          _vm.btnEnableList.indexOf("5") > -1
                                            ? _c(
                                                "a-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                  },
                                                  attrs: { icon: "printer" },
                                                  on: {
                                                    click: _vm.handlePrint,
                                                  },
                                                },
                                                [_vm._v("打印")]
                                              )
                                            : _vm._e(),
                                          _vm.btnEnableList.indexOf("3") > -1
                                            ? _c(
                                                "a-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                  },
                                                  attrs: { icon: "download" },
                                                  on: {
                                                    click: _vm.exportExcel,
                                                  },
                                                },
                                                [_vm._v("导出")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("section", { attrs: { id: "reportPrint" } }, [
                          _c(
                            "div",
                            { staticClass: "box-body form-inline detail-head" },
                            [
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v("利润"),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v("="),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v("收入"),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v("-"),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v("支出"),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "box-body form-inline detail-head" },
                            [
                              _c("div", { staticClass: "detail-head-group" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-red",
                                    attrs: { id: "profit" },
                                  },
                                  [_vm._v("￥" + _vm._s(_vm.profitText))]
                                ),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v(" "),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _c("span", { attrs: { id: "incomeTotal" } }, [
                                  _vm._v(_vm._s(_vm.incomeText)),
                                ]),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _vm._v(" "),
                              ]),
                              _c("div", { staticClass: "detail-head-group" }, [
                                _c("span", { attrs: { id: "paymentTotal" } }, [
                                  _vm._v(_vm._s(_vm.paymentText)),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "box-body form-inline detail-item" },
                            [
                              _c("ul", [
                                _c("li", [
                                  _c(
                                    "div",
                                    { staticClass: "group-head-left" },
                                    [_c("b", [_vm._v("项目列表")])]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-head-right" },
                                    [_c("b", [_vm._v("本期金额（元）")])]
                                  ),
                                ]),
                                _c("li", [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("【收入类】")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v(_vm._s(_vm.incomeTotal)),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("零售出库")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.retailOut))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("销售订单")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.saleOrder))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("销售出库")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.saleOut))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("采购退货")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.purchaseBack))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("盘盈")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.stockCheckProfit))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("收入单")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.itemIn))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("收款单")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.moneyIn))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("收预付款")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.advanceIn))]
                                  ),
                                ]),
                                _c("li", [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("【支出类】")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v(_vm._s(_vm.paymentTotal)),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("零售退货")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.retailBack))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("销售退货")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.saleBack))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("采购订单")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.purchaseOrder))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("采购入库")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.purchaseIn))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("盘亏")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.stockCheckLoss))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("支出单")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.itemOut))]
                                  ),
                                ]),
                                _c("li", { staticClass: "item-padd" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("付款单")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [_vm._v(_vm._s(_vm.moneyOut))]
                                  ),
                                ]),
                                _c("li", [
                                  _c(
                                    "div",
                                    { staticClass: "group-item-left" },
                                    [_vm._v("利润")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "group-item-right" },
                                    [
                                      _c("span", { staticClass: "text-red" }, [
                                        _vm._v(_vm._s(_vm.profitText)),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "form-tip" }, [
                            _vm._v(
                              "注：销售订单只统计订金，销售出库只统计收款，订金+收款=订单应收金额；采购订单只统计订金，采购入库只统计付款，订金+付款=订单应付金额"
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.printMode
        ? [
            _c(
              "div",
              {
                staticClass: "print-header",
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center",
                  padding: "8px 16px",
                  background: "#fff",
                  "border-bottom": "1px solid #e8e8e8",
                  "margin-bottom": "12px",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "font-size": "16px", "font-weight": "500" },
                  },
                  [_vm._v(_vm._s(_vm.printTitle))]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { icon: "close" },
                    on: {
                      click: function ($event) {
                        _vm.printMode = false
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
            _c("ReportPrint", {
              attrs: {
                visible: true,
                tableData: _vm.printItems,
                queryParam: _vm.printQueryParam,
                billType: "PROFIT_REPORT",
                billTypeName: "利润报表",
                buildData: _vm.buildPrintData,
                embedded: true,
              },
              on: { "designer-change": _vm.onDesignerChange },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }